import { VZButton } from 'components/Button/button.styles';
import { Col as GridCol, colWidth } from 'components/Grid';
import styled, { css, desktop, gapSize, rem, screenMobilePlusAndSmaller } from 'theme';
import boxShadow from 'theme/global/box-shadow';

export const QuickLinks = styled.div`
  position: relative;
  background: var(--ref-color-blackwhite-white);
  box-shadow: ${boxShadow.section};
  padding: ${() => gapSize(2.5)} 0 ${() => gapSize(4)} 0;

  ${screenMobilePlusAndSmaller(css`
    ${GridCol} {
      &:last-child {
        margin-top: 0;
      }
    }
  `)};
`;

export const Col = styled(GridCol)`
  ${(p) => p.l && desktop(colWidth(p.l || p.m || p.s || 0, gapSize(2.25), 12))}

  ${desktop(css`
    &:last-child {
      margin-right: 0;
    }

    &:first-child {
      margin-left: 0;
    }
  `)}
`;

export const Header = styled.span`
  font-size: var(--ref-font-size-lg);
  line-height: ${rem(24)};
  font-weight: var(--ref-font-weight-600);
`;

export const QuickLink = styled(VZButton)`
  display: block;
  padding: 0;
  align-self: start;
  font-weight: var(--ref-font-weight-600);

  :hover {
    text-decoration: underline;
  }

  ${desktop(css`
    white-space: nowrap;
    text-overflow: clip;
    overflow: visible;
  `)}

  svg {
    vertical-align: middle;
    margin-right: ${rem(16)};

    &:first-child {
      height: ${rem(20)};
      width: ${rem(20)};
    }

    &:last-child {
      position: relative;
      top: ${rem(-1)};

      margin-left: ${rem(8)};
    }
  }
`;
